// src/components/chat/AttachmentsPreview.jsx
import React from 'react';
import { getFileIcon, truncateFileName  } from '../../utils/fileHelpers';
import { formatFileSize } from '../../utils/formatters';

import './AttachmentsPreview.css';

const AttachmentsPreview = ({ attachments, onRemove }) => {
    if (!attachments || attachments.length === 0) return null;

    return (
        <div className="attachments-preview">
            {attachments.map((file, idx) => {
                const isImage = file.type.startsWith('image/');
                const fileIcon = getFileIcon(file.name);
                const fileSize = formatFileSize(file.size);
                const displayName = truncateFileName(file.name, 25);

                if (isImage) {
                    return (
                        <div key={idx} className="attachment-preview">
                            <img src={URL.createObjectURL(file)} alt="" />
                            <button onClick={() => onRemove(idx)}>
                                <i className="bi bi-x"></i>
                            </button>
                        </div>
                    );
                }

                return (
                    <div key={idx} className="attachment-preview-file">
                        <div className="attachment-preview-icon">
                            <i className={fileIcon}></i>
                        </div>
                        <div className="attachment-preview-info">
                            <div className="attachment-preview-name" title={file.name}>
                                {displayName}
                            </div>
                            <div className="attachment-preview-size">{fileSize}</div>
                        </div>
                        <button onClick={() => onRemove(idx)}>
                            <i className="bi bi-x"></i>
                        </button>
                    </div>
                );
            })}
        </div>
    );
};

export default AttachmentsPreview;